/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSON, FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSON, } from './FxIdApplicationStoreBank131DisableRecurrentPaymentResponse';
import { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON, } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseFromJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Data': FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseToJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Data': FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse.js.map